<!-- 动态管理 -->
<template>
    <div>
        <el-card class="box-card">
            <div class="text item">
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple">
                            <el-form :inline="true" class="demo-form-inline" size="small"
                                style="text-align: left;margin-top:5px;height:30px" ref="Searchform" :model="Search">
                                <!-- <el-row>
                                    <el-col :span="6"> -->
                                        <el-form-item label="学校" prop="school_id">
                                            <el-select v-model="Search.school_id" filterable remote placeholder="请输入学校关键词"
                                                :remote-method="getSchoolBySchoolName" :loading="school_loading">

                                                <el-option v-for="item in school_options" :key="item.schoolId"
                                                    :label="item.schoolName" :value="item.schoolId">
                                                </el-option>

                                            </el-select>
                                        </el-form-item>
                                    <!-- </el-col>
                                    <el-col :span="6"> -->
                                        <el-form-item label="用户名" prop="user_id">
                                            <el-select v-model="Search.user_id" filterable remote placeholder="请输入用户名关键词"
                                                :remote-method="getjpUserByjpNickName" :loading="school_loading">

                                                <el-option v-for="item in user_options" :key="item.id"
                                                    :label="item.jpNickName" :value="item.id">
                                                </el-option>

                                            </el-select>
                                        </el-form-item>
                                    <!-- </el-col>
                                    <el-col :span="6"> -->
                                        <el-form-item label="动态标题" prop="dynamic_title">
                                            <el-input v-model="Search_unSure.dynamic_title" placeholder="请输入标题关键词"
                                                clearable></el-input>
                                        </el-form-item>
                                    <!-- </el-col> -->
                                    <!-- <el-col :span="6"> -->
                                        <el-form-item>
                                            <el-button icon="el-icon-search" type="primary" size="mini"
                                                @click="getDynamicList()">查询</el-button>
                                            <el-button icon="el-icon-refresh" size="mini" @click="ClearSearchform()">重置</el-button>
                                        </el-form-item>
                                    <!-- </el-col> -->
                                <!-- </el-row> -->
                            </el-form>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="grid-content bg-purple-light">
                            <el-table 
                                :data="tableData_dynamic" 
                                border 
                                style="width: 100%" 
                                max-height="600"
                                :default-sort="{prop: 'createTime', order: 'descending'}">
                                <el-table-column prop="schoolName" label="发布学校" width="180" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="jpNickName" label="发布人" width="120" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="createTime" label="发布时间" width="180" sortable>
                                    <template slot-scope="scope">
                                        <i class="el-icon-time"></i>
                                        <span style="margin-left: 10px">{{ scope.row.createTime | dateFormat }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="dynamicTitle" label="动态标题" min-width="200" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="dynamicLikes" label="获赞数" width="90" sortable align="center">
                                </el-table-column>
                                <el-table-column prop="dynamicCollections" label="收藏数" width="90" sortable align="center">
                                </el-table-column>
                                <el-table-column label="操作" width="180" align="center" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button type="primary" icon="el-icon-search" size="mini"
                                            @click="toDetail(scope.row)">查看</el-button>
                                        <el-button type="danger" icon="el-icon-delete" size="mini"
                                            @click="toDelete(scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 20px;">
                    <el-col :span="24">
                        <div style="text-align: center;">
                            <el-pagination 
                                v-if="tableData_dynamic.length != 0"
                                background 
                                layout="total, prev, pager, next, jumper" 
                                :total="total" 
                                :current-page="queryObj.page"
                                :page-size="queryObj.limit"
                                @size-change="handleSizeChange" 
                                @current-change="handleSizeChange">
                            </el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            Search: {//搜索内容
                school_id: null,//学校
                user_id: null,//用户
            },
            Search_unSure: {//模糊搜索内容
                dynamic_title: '',//标题
            },
            total: 0,//分页总条目
            tableData_dynamic: [],//表格数据(动态)
            school_options: [],//学校下拉列表
            user_options: [],//用户下拉列表
            school_loading: false,//搜索加载
            queryObj: {//分页渲染条件
                limit: 8,//行
                page: 1,//页数
                query: "",//条件
            },
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 查看展开
        toDetail(Data){
            this.$message.warning("该功能暂未开发!")
        },
        // 点击删除
        toDelete(Data) {
            this.$confirm('确定删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const { data: res } = await this.$http.delete('dynamic/delDynamic', {
                    params: {
                        dynamicId: Data.dynamicId,
                    }
                });
                if (res.code == 200) {
                    this.$message({ type: "success", message: "删除成功!" })
                    this.getDynamicList()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        //分页交互调用事件
        handleSizeChange(newPage) {
            this.queryObj.page = newPage;
            this.getDynamicList();
        },
        // 拼接字符串条件
        Query(Str) {
            for (var key in Str) {
                if (Str[key] == '' || Str[key] == null) {
                    delete Str[key]
                }
            }
            let str = JSON.stringify(Str).replace(/(\{")/g, "").replace(/(\":)/g,' = ').replace(/}/g,'').replace(/,"/g, ' and ').replace(/{/g, '').replace(/"/g, '%"').replace('= %"', '= "%');
            return str
        },
        // 重新渲染表格
        // 渲染表格数据(动态)数据
        async getDynamicList() {
            let str = this.Query(this.Search);
            // console.log(str.length);
            if (str.length==0&&this.Search_unSure.dynamic_title!='') {
                str+=this.Search_unSure.dynamic_title
            }else if(str.length!=0&&this.Search_unSure.dynamic_title!=''){
                str+=' and dynamic_title like "'+this.Search_unSure.dynamic_title+'"'
            }
            // console.log(str);
            this.queryObj.query = str
            const { data: res } = await this.$http.get('/dynamic/getDynamicList',
                {
                    params: this.queryObj
                });
            // console.log(res)
            this.tableData_dynamic = res.data.children;
            this.total = res.data.total
        },
        // 重置搜索表单
        ClearSearchform() {
            console.log("重置搜索表单");
            this.$refs.Searchform.resetFields()
            this.Search_unSure.dynamic_title=''
        },
        // 学校下拉搜索
        async getSchoolBySchoolName(query) {
            if (query !== '') {
                this.school_loading = true;
                const { data: res } = await this.$http.get('/school/getSchoolBySchoolName',
                    {
                        params: { schoolName: query }
                    });
                // console.log(res)
                setTimeout(() => {
                    this.school_loading = false;
                    this.school_options = res.data
                }, 200);
            } else {
                this.school_options = [];
            }
        },
        async getjpUserByjpNickName(query){
            if (query !== '') {
                this.school_loading = true;
                const { data: res } = await this.$http.get('/campususer/getjpUserByjpNickName',
                    {
                        params: { jpNickName: query }
                    });
                // console.log(res)
                setTimeout(() => {
                    this.school_loading = false;
                    this.user_options = res.data
                }, 200);
            } else {
                this.user_options = [];
            }
        }
    },
    created() { },
    mounted() {
        this.getDynamicList()
     }
};
</script>
<style scoped>
.box-card {
    width: 100%;
}
.item {
    margin-bottom: 18px;
}

.grid-content {
    margin: 20px 0;
}
</style>
